import React from "react";
import ReactDOM from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./auth/authConfig";
import {
  rememberDeviceAccount,
  clearDeviceLoginHint,
} from "./auth/deviceLoginHint";
import { initTranslations, SupportedLocale } from "@preppa/translation";
import "./index.css";
import App from "./App";

// Initialize translations with saved locale or default to English
const savedLocale = localStorage.getItem("locale") as SupportedLocale | null;
initTranslations({
  locale: savedLocale || "en",
  defaultLocale: "en",
});

const msalInstance = new PublicClientApplication(msalConfig);

function renderApp() {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
}

msalInstance
  .initialize()
  .then(() =>
    msalInstance.handleRedirectPromise().catch((error) => {
      console.error("Error handling redirect:", error);
      clearDeviceLoginHint();
      return null;
    }),
  )
  .then((result) => {
    if (result) {
      rememberDeviceAccount(result.account);
    }

    renderApp();
  })
  .catch((error) => {
    console.error("Error initializing MSAL:", error);
    renderApp();
  });
